import { FormsData } from "@/modules/Forms/models/FormsData";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { SearchFilter } from "@/shared/models/SearchFilter";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import { mapGetters } from "vuex";
import { PROFILE_CONSTANTS } from "../../constants/ProfileConstants";
import { SelectRef } from "../../models/SelectRef";

Vue.use(Vuetify);
@Component({
  name: "FilterSearch",
  computed: {
    ...mapGetters({
      panelView: "getPanelView"
    })
  }
})
export default class FilterSearch extends Vue {
  @Prop({ default: [] }) private filterItems!: SearchFilter[];
  @Prop() private generalData!: FormsData[] | ServiceHeaderData[];
  @Prop() private whereAmI!: string;

  btnClassRoundPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  arrayFilters: string[][] = [[]];
  filterNamesTags = PROFILE_CONSTANTS.FILTER_NAMES_TAGS;
  chipsInnerName = PROFILE_CONSTANTS.CHIPS_INNER_NAME;
  whereLocation = PROFILE_CONSTANTS.WHERE_LOCATION;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  itemChosenValue = "";
  categoryStateChosen = "";
  panelView!: boolean;
  inputFilter = "";
  filterItemsAux: SearchFilter[] = [];
  selectItems: string[] = [];
  selectTagText = "";
  showSelect = true;

  mounted() {
    this.filterItemsAux = this.filterItems.map(e => e);
    this.getServiceFilterItems();
  }
  getServiceFilterItems() {
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.VALUE) {
      let categoryList: string[] = [];
      let stateList: string[] = [];
      (this.generalData as ServiceHeaderData[]).forEach(service => {
        if (!categoryList.includes(service.category)) {
          categoryList = [...categoryList, service.category];
        }
        if (!stateList.includes(service.state)) {
          stateList = [...stateList, service.state];
        }
      });
      this.arrayFilters = [categoryList, stateList];
      return [categoryList, stateList];
    }
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.VALUE) {
      let categoryList: string[] = [];
      const roleList: string[] = [];
      (this.generalData as FormsData[]).forEach(task => {
        if (!categoryList.includes(task.formTemplate.category)) {
          categoryList = [...categoryList, task.formTemplate.category];
        }
      });
      this.arrayFilters = [categoryList, roleList];
    }
  }

  chosenItem(item: string) {
    this.itemChosenValue = item;
    if (this.categoryStateChosen === "") return;
    if (this.filterItemsAux) {
      this.filterItemsAux = this.filterItemsAux.map(each => {
        if (each.id === this.categoryStateChosen) {
          return { ...each, value: item };
        }
        return each;
      });
      this.activateFilter();
    }
    (this.$refs.selectList as Vue & SelectRef).$refs.menu.isActive = false;
    this.selectItems = [];
  }

  categoryValue(item: string, itemsArray: string[]) {
    this.categoryStateChosen = item;
    const actualObj = this.filterItems.filter(e => e.id === item);
    this.selectTagText = PROFILE_CONSTANTS.SELECCIONE_UNA + actualObj[0].name;
    this.selectItems = itemsArray;
    (this.$refs.selectList as Vue & SelectRef).$refs.menu.isActive = true;
  }
  filterServices(
    category: string,
    item: string,
    data: FormsData[] | ServiceHeaderData[]
  ) {
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.VALUE) {
      if (category && item) {
        if (
          category === PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.SUB.CATEGORY
        ) {
          const filteredData = (data as ServiceHeaderData[]).filter(
            service => service.category === item
          );
          return filteredData;
        } else {
          const filteredData = (data as ServiceHeaderData[]).filter(
            service => service.state === item
          );
          return filteredData;
        }
      }
    }
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.VALUE) {
      if (category && item) {
        if (category === PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.SUB.CATEGORY) {
          const filteredData = (data as FormsData[]).filter(
            task => task.formTemplate.category === item
          );
          return filteredData;
        }
        if (
          category === PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.SUB.TASKROLENAME
        ) {
          const filteredData = data as FormsData[];
          return filteredData;
        }
      }
    }
  }

  regInsensitive(inputText: string) {
    return inputText
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  filterServicesByName() {
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.VALUE) {
      if (this.inputFilter) {
        const filteredData = (this.generalData as ServiceHeaderData[]).filter(
          service => {
            const fromArray = this.regInsensitive(service.internalName);
            const myInput = this.regInsensitive(this.inputFilter);

            if (fromArray.includes(myInput)) {
              return fromArray;
            }
          }
        );
        return filteredData;
      }
    }
    if (this.whereAmI === PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.VALUE) {
      if (this.inputFilter) {
        const filteredData = (this.generalData as FormsData[]).filter(task => {
          const fromArray = task.formTemplate.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const myInput = this.inputFilter
            .toLocaleLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          if (fromArray.includes(myInput)) {
            return fromArray;
          }
        });
        return filteredData;
      }
    }
  }

  activateFilter() {
    const fullValueFiltered = this.filterItemsAux.filter(e => e.value !== "");

    let init = this.generalData;

    fullValueFiltered.forEach(e => {
      init = this.filterServices(e.id, e.value, init) ?? [];
    });

    this.$emit(PROFILE_CONSTANTS.CHANGE_SERVICES, init);
  }

  allItems() {
    if (this.filterItemsAux) {
      this.filterItemsAux = this.filterItemsAux.map(each => {
        return { ...each, value: "" };
      });
    }
    this.$emit(PROFILE_CONSTANTS.CHANGE_SERVICES, this.generalData);
  }

  @Watch(PROFILE_CONSTANTS.INPUT_FILTER, { deep: true })
  searchItems() {
    if (this.inputFilter && this.inputFilter.length > 0) {
      const filtering = this.filterServicesByName();
      if (filtering) {
        this.$emit(PROFILE_CONSTANTS.CHANGE_SERVICES, filtering);
      }
    } else {
      (this.$refs.selectList as Vue & SelectRef).$refs.menu.isActive = false;
      this.allItems();
    }
  }
}
